import { Button, TableCell, TableRow } from '@mui/material';
import { styled } from '@mui/material/styles';

// VendorList styles ----------------------------------------------------------

export const FlexColumn = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const RealmList = styled('div')({
  // Was an empty class in the original — kept as a thin wrapper for the page root.
});

export const InnerContainer = styled('div')(({ theme }) => ({
  padding: `0 ${theme.spacing(4)}`,

  '& h6': {
    fontSize: 14,
  },

  '& .MuiCheckbox-root': {
    padding: 1,
  },
  '& .MuiFormControlLabel-root': {
    marginLeft: 0,
  },
}));

export const EditVendorsButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(1),
}));

export const RealmContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hideBorders',
})(({ theme, hideBorders }) => ({
  position: 'relative',
  borderTop: hideBorders ? 'none' : `1px solid black`,
  margin: `${theme.spacing(2)} 0`,
}));

export const Realm = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hideBorders',
})(({ theme, hideBorders }) => ({
  padding: theme.spacing(1),
  position: 'relative',
  borderBottom: hideBorders ? 'none' : `1px solid black`,
}));

export const DeleteVendorBtn = styled(Button)(({ theme }) => ({
  position: 'absolute',
  top: 5,
  right: 5,
  color: theme.palette.error.main,
}));

// TradesList styles (formerly `tradeStyles`) ---------------------------------

export const TradesContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(1),
  '& .MuiTableCell-root': {
    fontSize: 14,
    padding: theme.spacing(1, 2),
  },
  '& tbody tr:last-child td': {
    borderBottom: 'none',
  },
}));

export const TradesHeaderCell = styled(TableCell)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.text.secondary,
  fontSize: '13px !important',
  borderBottom: `2px solid ${theme.palette.divider}`,
}));

export const TradesEnabledRow = styled(TableRow)(({ theme }) => ({
  '& td': { color: theme.palette.text.primary },
}));

export const TradesDisabledRow = styled(TableRow)(({ theme }) => ({
  '& td': {
    color: theme.palette.text.disabled,
    fontStyle: 'italic',
  },
}));

export const TradesDisabledCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.text.disabled,
  fontStyle: 'italic',
}));
